





import Vue from 'vue'
import Component from 'vue-class-component'

@Component({})
class FolderItemView4ProductResourceView extends Vue {
  //
}

export default FolderItemView4ProductResourceView

